import { AdvancedSeatIcon, CoreSeatIcon, FreeSeatIcon, UnlimitedSeatIcon } from '@/components/TeamSeatIcons'

export interface TeamContent {
  id: string
  type: 'set' | 'doc' | 'rubric' | 'link' | 'video'
  value_type: string
  value: any
  name: string
  description?: string
  createdAt: any
  creatorName?: string
  creatorId?: string
  folderId?: string
}

export const teamContentTypeDefinitions = {
  rubric: {
    type: 'rubric',
    value_type: 'id',
    collection: 'rubrics',
  },
  set: {
    type: 'set',
    value_type: 'id',
    collection: 'sets',
  },
  doc: {
    type: 'doc',
    value_type: 'url',
    collection: null,
  },
  link: {
    type: 'link',
    value_type: 'url',
    collection: null,
  },
  video: {
    type: 'video',
    value_type: 'url',
    collection: null,
  },
}

export interface TeamSeatType {
  id: 'free_tier' | 'core_team_seat' | 'advanced_team_seat' | 'unlimited_team_seat'
  name: 'Free' | 'Core' | 'Advanced' | 'Unlimited'
  description: 'Free Tier' | 'Core Team Seat' | 'Advanced Team Seat' | 'Unlimited Team Seat'
  color: 'default' | 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | string
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  featureText: string
}

export const teamSeatTypes: TeamSeatType[] = [
  {
    id: 'free_tier',
    name: 'Free',
    description: 'Free Tier',
    color: 'warning',
    icon: FreeSeatIcon,
    featureText: 'Limited Features',
  },
  {
    id: 'core_team_seat',
    name: 'Core',
    description: 'Core Team Seat',
    color: 'primary',
    icon: CoreSeatIcon,
    featureText: '1000 Credits / Month',
  },
  {
    id: 'advanced_team_seat',
    name: 'Advanced',
    description: 'Advanced Team Seat',
    color: 'secondary',
    icon: AdvancedSeatIcon,
    featureText: '2000 Credits / Month',
  },
  {
    id: 'unlimited_team_seat',
    name: 'Unlimited',
    description: 'Unlimited Team Seat',
    color: 'success',
    icon: UnlimitedSeatIcon,
    featureText: 'No Credit Limit',
  },
]
